export const GET_LOCATIONS_REQUEST = 'SESSIONS_BULK_UPDATE_GET_LOCATIONS_REQUEST';
export const GET_LOCATIONS_SUCCESS = 'SESSIONS_BULK_UPDATE_GET_LOCATIONS_SUCCESS';
export const GET_ORGANIZATIONS_REQUEST = 'SESSIONS_BULK_UPDATE_GET_ORGANIZATIONS_REQUEST';
export const GET_ORGANIZATIONS_SUCCESS = 'SESSIONS_BULK_UPDATE_GET_ORGANIZATIONS_SUCCESS';
export const GET_PEOPLE_REQUEST = 'SESSIONS_BULK_UPDATE_GET_PEOPLE_REQUEST';
export const GET_PEOPLE_SUCCESS = 'SESSIONS_BULK_UPDATE_GET_PEOPLE_SUCCESS';
export const UPDATE_SESSIONS_REQUEST = 'SESSIONS_BULK_UPDATE_UPDATE_SESSIONS_REQUEST';
export const UPDATE_SESSIONS_SUCCESS = 'SESSIONS_BULK_UPDATE_UPDATE_SESSIONS_SUCCESS';
export const DISPOSE = 'SESSIONS_BULK_UPDATE_DISPOSE_STORE';
